import { ResetFieldConfig } from "react-hook-form";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { CalendarEventType, PlatformModules } from "@miplatform/types";
import { useCalendarSets } from "../../../../hooks";
import { MODULES_CONFIG_PATHS } from "../../../../routes/config/constants";
import { CALENDAR_PAGE_CONFIG } from "../ConfigCalendarSetList.constants";
import { ICalendarSetData } from "../ConfigCalendarSetList.types";

export const useCalendarSetDetailsViewModel = ({
  module,
  eventType,
  reset,
}: {
  module: PlatformModules;
  eventType: CalendarEventType;

  reset: (
    data?: Partial<ICalendarSetData>,
    options?: ResetFieldConfig<ICalendarSetData>
  ) => void;
}) => {
  const { navigate } = useRouter();
  const {
    isLoading,
    calendarSetDetails,
    getCalendarSetDetails,
    updateCalendarSet,
    updateCalendarSetStatus,
    createCalendarSetWithCapacities,
  } = useCalendarSets({
    reset,
  });

  const createCalendarSet = async (data: ICalendarSetData) => {
    const response = await createCalendarSetWithCapacities(data);

    if (response.status === HTTP_STATUSES.OK) {
      navigate(
        MODULES_CONFIG_PATHS[module][CALENDAR_PAGE_CONFIG[eventType].configPage]
      );
    }
  };

  return {
    isLoading,
    calendarSetDetails,
    getCalendarSetDetails,
    updateCalendarSet,
    updateCalendarSetStatus,
    createCalendarSet,
  };
};
